import { ignoreUndo } from "../undo";
import { getSheet } from "../../sheets";
import { getGroups } from "./state";

export function isInactiveSheet(view, page) {
	return page && page !== view.getActiveSheet();
}

export function refreshGroupView(view, type) {
	const v = view.$$(type === "row" ? "rowGroups" : "columnGroups");
	if (v) v.render();
	const intersection = view.$$("groupIntersection");
	if (intersection) intersection.render();
}

export function getSheetGroups(sheet, type) {
	const t = sheet.content.table;
	return t && t.groups && t.groups[type] ? t.groups[type] : [];
}

export function setSheetGroups(sheet, type, groups) {
	if (!sheet.content.table) sheet.content.table = {};
	if (!sheet.content.table.groups) sheet.content.table.groups = {};
	sheet.content.table.groups[type] = groups;
}

export function resolveGroups(view, type, page) {
	if (isInactiveSheet(view, page)) {
		const sheet = getSheet(view, page);
		if (!sheet) return [];
		return getSheetGroups(sheet, type);
	}
	return getGroups(view, type);
}

export function withGroupSync(view, fn, ignore = true) {
	view._groupSyncing = true;
	if (ignore) ignoreUndo(fn, view);
	else fn();
	view._groupSyncing = false;
}

export function mapGroups(groups) {
	return groups.map(g => ({
		start: g.start,
		end: g.end,
		level: g.level,
		open: g.open,
	}));
}

export function isGroupingAllowed(view) {
	const zones = Object.keys(view.$$("cells").getAllSelectAreas());
	if (zones.length > 1) {
		view.alert({
			text: webix.i18n.spreadsheet.labels["error-group-multiselect"],
			type: "alert-error",
		});
		return false;
	}
	return true;
}
